import { Fab, Grid, TextField, Button, FormControl, InputLabel, Select } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { useState, useEffect } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-toastify';
import { createUser } from '../../../api/cms/user';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { useConfirm } from 'material-ui-confirm';
import { getRoleOptions } from 'store/user';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
    position: 'relative',
    minHeight: 200,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

let schema = yup.object().shape({
  platform_name: yup.string().required(),
  email: yup.string().email().required(),
  password: yup.string().min(5).required(),
  //contact_person: yup.string().required(),
  domain: yup.string(),
  platform_code: yup.string().length(5).lowercase().required(),
  preset_code: yup.string(),
});

const CreateUserModal = ({ onSubmitSuccess }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const confirm = useConfirm();
  const roleOptions = getRoleOptions().filter((role) => role.value !== 1);

  const {
    control,
    handleSubmit,
    formState: { errors },
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      is_active: false,
      two_fa: false,
      platform_name: '',
      email: '',
      password: '',
      contact_person: '',
      domain: '',
      merchant_code: '',
      platform_code: '',
      preset_code: '',
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    reset();
  };

  const onConfirm = (id) => {
    history.push(`/admin/user_list/${id}`);
  };

  const onCloseConfirm = () => {
    handleClose();
    onSubmitSuccess();
  };

  const onSubmit = (values) => {
    // console.log('values', values);
    let formData = new FormData();
    for (const [key, value] of Object.entries(values)) {
      formData.append(key, value);
    }
    createUser(formData)
      .then((data) => {
        console.log('res', data);
        toast.success('updated');
        confirm({
          title: 'Create Success',
          description: `Do you want to go ${data.username} Info Page`,
        })
          .then(() => onConfirm(data.user_id))
          .catch(() => onCloseConfirm());
      })
      .catch((error) => {
        toast.error(_.get(error, 'response.data.message', 'error'));
      });
  };

  return (
    <>
      <Fab
        className={classes.fab}
        color="primary"
        onClick={handleClickOpen}
        style={{ zIndex: 100 }}
      >
        <AddIcon />
      </Fab>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-platform">
        <DialogTitle id="form-dialog-platform">Create New Platform</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{ display: 'none', gap: 16, alignItems: 'center', marginTop: 16 }}
              >
                <Controller
                  name="is_active"
                  control={control}
                  defaultValue={false}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          color="secondary"
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />
                      }
                      label="Active"
                    />
                  )}
                />

                <Controller
                  name="two_fa"
                  control={control}
                  defaultValue={false}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          color="secondary"
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />
                      }
                      label="2FA"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="username"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Username"
                      type="text"
                      error={!!errors?.username}
                      {...field}
                      helperText={errors?.username?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="password"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Password"
                      type="password"
                      error={!!errors?.password}
                      {...field}
                      helperText={errors?.password?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="platform_code"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Platform Code"
                      type="text"
                      error={!!errors?.platform_code}
                      {...field}
                      helperText={errors?.platform_code?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="platform_name"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Platform Name"
                      type="text"
                      error={!!errors?.platform_name}
                      {...field}
                      helperText={errors?.platform_name?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="contact_person"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Contact Name"
                      type="text"
                      id="contact_person"
                      error={!!errors?.contact_person}
                      {...field}
                      helperText={errors?.contact_person?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="merchant_code"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Merchant Code"
                      type="text"
                      id="merchant_code"
                      error={!!errors?.merchant_code}
                      {...field}
                      helperText={errors?.merchant_code?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="email"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Email"
                      type="text"
                      id="email"
                      error={!!errors?.email}
                      {...field}
                      helperText={errors?.email?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="domain"
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      label="Domain"
                      type="text"
                      id="email"
                      error={!!errors?.domain}
                      {...field}
                      helperText={errors?.domain?.message}
                    />
                  )}
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="role"
                  render={({ field }) => (
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: '100%' }}
                    >
                      <InputLabel id="role">Role</InputLabel>
                      <Select labelId="role" variant="outlined" fullWidth label="Role" {...field}>
                        <option aria-label="None" value="" selected />
                        {roleOptions?.map((role) => (
                          <option key={role.value} value={role.value}>
                            {role.label}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  control={control}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!formState.isDirty || formState.isSubmitting || !formState.isValid}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default CreateUserModal;
